import * as CONST from '../constants/index';
import { action } from 'typesafe-actions';


export const fetchDataApiSuccess = (data:any) => {
  return {
    type: CONST.FETCH_DATA_API_SUCCESS,
    payload: data,
  };
};

export const fetchDataLocal = (data:any) => {
  return {
    type: CONST.FETCH_DATA_LOCAL,
    payload: data,
  };
};

export const fetchDataApiError = (error:any) => {
  return {
    type: CONST.FETCH_DATA_API_ERROR,
    payload: error,
  };
};

export const getFilterData = (data:any) => {
  return {
    type: CONST.GET_FILTER_DATA,
    payload: data,
  };
};
export const filterTheData = (title?: string | null, name?: string | null, data?: any | null) => {
  return {
    type: CONST.FILTER_THE_DATA,
    payload: {'type_title': {'title': title, 'name': name}, 'data': data}
  };
};

export const fetchDataApi = () => action(CONST.FETCH_DATA_API, {});
